export { VirtusOnlyLayout as default } from '@/src/features/community/ui/layouts/VirtusOnlyLayout'
